/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import './ShareCardHeader.styles.scss';

interface Props {
  style: any;
}
const ShareCardHeader: React.FC<Props> = (props) => (
  <div className="cmp-sharecard-header" style={props.style}>
    {props.children}
  </div>
);

export default ShareCardHeader;
